import * as React from "react";
const SvgPlayVideo = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M18.57 11.142a1 1 0 0 1 0 1.715L6.515 20.09A1 1 0 0 1 5 19.233V4.765a1 1 0 0 1 1.514-.857l12.057 7.234Z"
      fill="#fff"
    />
  </svg>
);
export default SvgPlayVideo;
